import { onMounted, onUnmounted, Ref } from "vue";

/**
 * Καλεί το callback την πρώτη φορά που το element μπαίνει στο viewport.
 * Τα βαριά sections (retention, ops) δεν πληρώνονται αν ο admin δεν κατέβει.
 */
export function useLazySection(target: Ref<HTMLElement | null>, onVisible: () => void) {
  let observer: IntersectionObserver | null = null;

  onMounted(() => {
    if (!target.value) return;

    // Χωρίς IntersectionObserver (παλιό browser), φόρτωσε αμέσως.
    if (typeof IntersectionObserver === "undefined") {
      onVisible();
      return;
    }

    observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          onVisible();
          observer?.disconnect();
          observer = null;
        }
      },
      { rootMargin: "200px" }
    );

    observer.observe(target.value);
  });

  onUnmounted(() => {
    observer?.disconnect();
    observer = null;
  });
}
